import React from 'react';
import { Card, Form, Input, Button, message, Row, Col, Typography } from 'antd';
import { MailOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';

const { Title, Text } = Typography;

const PasswordReset: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  const submit = async (values: { email: string }) => {
    setLoading(true);
    try {
      await api.post('/api/auth/password-reset', { email: values.email });
      message.success('Если email существует в системе, письмо отправлено на него');
      form.resetFields();
      setTimeout(() => navigate('/'), 3000);
    } catch (e: any) {
      message.error(e?.response?.data?.error || 'Ошибка запроса');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f0f2f5',
      padding: '20px'
    }}>
      <Row justify="center" style={{ width: '100%' }}>
        <Col xs={22} sm={16} md={12} lg={8} xl={6}>
          <Card
            style={{
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
              borderRadius: '8px'
            }}
            variant="outlined"
          >
            <div style={{ textAlign: 'center', marginBottom: '28px' }}>
              <Title level={2} style={{ margin: 0, color: '#1890ff' }}>
                🔐 Восстановление пароля
              </Title>
              <Text type="secondary" style={{ fontSize: '14px', marginTop: '8px', display: 'block' }}>
                Введите email для восстановления
              </Text>
            </div>

            <Form
              form={form}
              name="password-reset"
              onFinish={submit}
              autoComplete="off"
              size="large"
              layout="vertical"
            >
              <Form.Item
                label="Email адрес"
                name="email"
                rules={[
                  { required: true, message: 'Введите email!' },
                  { type: 'email', message: 'Некорректный email!' }
                ]}
              >
                <Input
                  prefix={<MailOutlined />}
                  placeholder="your@email.com"
                  autoComplete="off"
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  style={{ width: '100%', height: '36px' }}
                >
                  Отправить ссылку для восстановления
                </Button>
              </Form.Item>
            </Form>

            <div style={{ textAlign: 'center', marginTop: '16px' }}>
              <Link to="/" style={{ color: '#1890ff', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                <ArrowLeftOutlined />
                Вернуться на вход
              </Link>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PasswordReset;
